import { Avatar, Col, List, Modal, Radio, RadioChangeEvent, Row } from "antd";
import { useState } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './Connection-Request.scss';
import { useSelector } from "react-redux";
import { Contact } from "../../../..";

interface Props {
    onOk: (value: any, rich: any) => void
    open: boolean,
    onCancel: () => void,
    contact: Contact
}

const ConnectionRequest = (props: Props) => {
    const [requestType, setRequestType] = useState('provider');

    const user = useSelector((state: any) => {
        return state.user.user;
    });

    const [value, setValue] = useState('');
    const [text, setText] = useState('');

    const handleOk = () => {
        props.onOk({ value, requestType}, text);
    };

    const handleCancel = () => {
        props.onCancel();
    };

    const onChange = (value: any, text: any) => {
        setValue(value);
        setText(text);
    };

    const onChangeRequestType = (e: RadioChangeEvent) => {
        setRequestType(e.target.value);
    };

    return (
        <Modal
            cancelText={'Cancelar'}
            okText="Conectar"
            title="Solicitud de Conexión"
            open={props.open}
            onOk={handleOk}
            onCancel={handleCancel}
        >
            <List
                itemLayout="horizontal"
                dataSource={[
                    {
                        name: props.contact.name || '',
                        email: props.contact.email || '',
                        organization_name: props.contact.organization_name || '',
                        type: props.contact.type || ''
                    }
                ]}
                renderItem={(item, index) => (
                    <List.Item>
                        <List.Item.Meta
                            style={{ margin: 0 }}
                            avatar={
                                <Avatar src={`https://api.dicebear.com/7.x/miniavs/svg?seed=${index}`} />
                            }
                            title={item.name}
                            description={props.contact?.type}
                        />
                    </List.Item>
                )}
            />
            <Row gutter={[8, 8]}>
                <Col lg={24}>
                    <p className="conecction-as-label">Solicitar conexión como:</p>
                </Col>
            </Row>
            <Row gutter={[8, 8]}>
                <Radio.Group onChange={onChangeRequestType} value={requestType}>
                    <Radio value='consumer'>Consumidor de conocimiento</Radio>
                    <Radio value='provider'>Proveedor de conocimiento</Radio>
                </Radio.Group>
            </Row>
            <br />
            <div style={{ height: 200 }}>
                <ReactQuill
                    style={{ height: "150px" }}
                    placeholder="Describe tu solicitud"
                    theme="snow"
                    value={value}
                    onChange={(content, delta, source, editor) => {
                        setValue(content)
                        setText(editor.getText());
                    }}
                />
            </div>
        </Modal>
    );
}

export default ConnectionRequest;